import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { SelectModule } from 'ng2-select';

import { AppComponent } from './app.component';
import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { FixedpluginModule } from './shared/fixedplugin/fixedplugin.module';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material';


//Ruotes
import { AppRoutes } from './app.routing';
//Guards
import { AuthGuard } from 'guards/auth.guard';
//Services
import { AuthService } from 'services/auth/auth.service';
import { Base64imagesService } from "services/base64images/base64images.service";
// import { GetalldataService } from 'services/getalldata/getalldata.service';
import { ThirdService } from 'services/third/third.service';
import { BrowserModule } from '@angular/platform-browser';
// import { AccountService } from 'services/account/account.service';
//import { TransactionService } from 'services/transaction/transaction.service';
import { CityesService } from 'services/cityes/cityes.service';
import { HostService } from 'services/host/host.service';
import { CurrencyService } from 'services/currency/currency.service'
import { UserIdleModule } from 'angular-user-idle';
import { InvocesComponent } from './student/invoces/invoces.component';
import { MaterialModule } from './material.module'
import { LogrosService } from 'services/logros/logros.service';
import { NotasService } from "services/notas/notas.service";
import { Logobase64Service } from "services/logobase64/logobase64.service";
import { CryptService } from 'services/crypt/crypt.service';
import { SidebarComponent } from './sidebar/sidebar.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';


@NgModule({

  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes),
    HttpModule,
    MaterialModule,
    MatNativeDateModule,
    SidebarModule,
    NavbarModule,
    FooterModule,
    FixedpluginModule,
    HttpClientModule,
    BrowserModule,
    ReactiveFormsModule,
    SelectModule,
    UserIdleModule.forRoot({ idle: 300, timeout: 1, ping: 300 }),
    ImageCropperModule
  ],
  exports: [
    MatMomentDateModule
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    PageNotFoundComponent,

  ],

  providers: [
    // AccountService,
    AuthGuard,
    AuthService,
    // EgressService,
    ThirdService,
    Base64imagesService,
    //TransactionService,
    CityesService,
    HostService,
    CurrencyService,
    LogrosService,
    NotasService,
    Logobase64Service,
    CryptService,
    SidebarComponent,
  ],

  bootstrap: [

    AppComponent

  ]

})

export class AppModule { }